import dayjs from 'dayjs'

const ACTIVITY_TYPE = Object.freeze({
  'REGULAR': 1,
  'LITE': 3,
  'BD_APP': 5,
})

const ACTIVITY_STATUS = {
  NOT_BEGIN: 0,
  OK: 1,
  WAIT: 2,
  DONE_SUCCESS: 3,
  WAIT_SUCCESS: 4,
  DONE_FAIL: 5,
  TIME_OVER: 6,
  OVER: 7,
  FULL: 8,
  UNPAID: 9
}
const getStatusInfo = status => {
  let info = ''
  switch (status) {
    case ACTIVITY_STATUS.NOT_BEGIN:
      //灰色
      info = '未开始'
      break
    case ACTIVITY_STATUS.OK:
      info = '报名活动'
      break
    case ACTIVITY_STATUS.WAIT:
      info = '报名等位'
      break
    case ACTIVITY_STATUS.DONE_SUCCESS:
      //绿色
      info = '报名成功'
      break
    case ACTIVITY_STATUS.WAIT_SUCCESS:
      //绿色

      info = '已报名，等位中'
      break
    case ACTIVITY_STATUS.DONE_FAIL:
      //灰色

      info = '报名失败'
      break
    case ACTIVITY_STATUS.TIME_OVER:
      //灰色

      info = '报名截止'
      break
    case ACTIVITY_STATUS.OVER:
      //灰色

      info = '已结束'
      break
    case ACTIVITY_STATUS.FULL:
      //灰色

      info = '名额已满'
      break
    case ACTIVITY_STATUS.UNPAID:
      //绿色

      info = `已报名（待支付）`
      break
    default:
      info = '报名活动'
      break
  }
  return info
}
const getStatusColor = status => {
  let info = ''
  switch (status) {
    case ACTIVITY_STATUS.NOT_BEGIN:
      //灰色
      info = '#d2d2d2'
      break
    case ACTIVITY_STATUS.OK:
      info = false
      break
    case ACTIVITY_STATUS.WAIT:
      info = false
      break
    case ACTIVITY_STATUS.DONE_SUCCESS:
      //绿色
      info = '#07c160'
      break
    case ACTIVITY_STATUS.WAIT_SUCCESS:
      //绿色

      info = '#07c160'
      break
    case ACTIVITY_STATUS.DONE_FAIL:
      //灰色

      info = '#d2d2d2'
      break
    case ACTIVITY_STATUS.TIME_OVER:
      //灰色

      info = '#d2d2d2'
      break
    case ACTIVITY_STATUS.OVER:
      //灰色

      info = '#d2d2d2'
      break
    case ACTIVITY_STATUS.FULL:
      //灰色

      info = '#d2d2d2'
      break
    case ACTIVITY_STATUS.UNPAID:
      //绿色

      info = `#07c160`
      break
    default:
      info = false
      break
  }
  return info
}

const imgSwiper = {
  props: ['imgList'],
  render(h) {
    const swiperOption = {
      autoplay: true,
      pagination: {
        el: '.swiper-pagination'
      }
    }
    return (
      <swiper options={swiperOption} ref="mySwiper">
        {this.imgList.map((item, index) => (
          <swiper-slide key={index}>
            <img style={{ width: '100%', height: '9.3rem', 'object-fit': 'cover' }} src={item} alt="swiper" />
          </swiper-slide>
        ))}
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    )
  }
}
const listItemExpansion = {
  functional: true,
  props: ['data', 'themeColor','orgId'],
  render(h, context) {
    let banner = ''
    let backgroundImageType = ''
    let {config:{module,common,page}} = context.props.data
    //判断营销应用的banner
    if(module !== undefined){
      let {elements:{banner:actBanner}} = module
      if(actBanner.images) {
        banner = actBanner.images[0]
      }else{
        banner = actBanner.src
      }

      if(page.homePage.background.indexOf('http') !== -1) {
        backgroundImageType = `background:url(${page.homePage.background}) no-repeat top center;background-size:100%`
      }else{
        backgroundImageType = `background-color:${page.homePage.background}`
      }
    }else {
      //获取活动管家
      let {banner:marketBanner} = common
      banner = marketBanner[0]
    }
    console.log(backgroundImageType)
    return (
      <div class="list-item-expansion" onClick={context.listeners.click} data-link={context.data.attrs['data-link']}>
        <div class="top" style={backgroundImageType}>
          <img src={banner} alt=""/>
        </div>
        <div class="bottom">
          <div class="title">
            <span class="txt">{context.props.data.title}</span>
            {
              context.props.data.activity_status === '0'
                ? (
                  <span class="label uninitiated">未发布</span>
                ) : (
                  <span class="label" style={{backgroundColor: getStatusColor(context.props.data.status)?getStatusColor(context.props.data.status):context.props.themeColor}}>{getStatusInfo(context.props.data.status)}</span>
                )
            }
          </div>
          {
            [ACTIVITY_TYPE.REGULAR, ACTIVITY_TYPE.BD_APP].includes(+context.props.data.type) ? (
              <div class="desc">
                <div class="area">{context.props.data.start_time}</div>
                {
                  (+context.props.orgId !== 385644) && (<div class="party">
                    <span
                      class="num"
                      style={{color: context.props.themeColor}}>
                      {context.props.data.join_count}</span>
                    <span>报名&nbsp;·&nbsp;</span>
                    <span
                      class="num"
                      style={{color: context.props.themeColor}}>
                      {context.props.data.view_count}</span>
                    <span>浏览</span>
                  </div>)
                }

              </div>
            ) : (
              <div class="description">
                <div class="item">
                    活动时间：{context.props.data.config.common.time}
                </div>
                <div class="item">
                    参与对象：{context.props.data.config.common.targetGroup}
                </div>
                <div class="desc">
                  <div class="area">
                    活动地址：{context.props.data.config.common.address}
                  </div>
                  {
                    (+context.props.orgId !== 385644) && (<div class="party">
                      <span
                        class="num"
                        style={{color: context.props.themeColor}}>
                        {context.props.data.join_count}</span>
                      <span>报名&nbsp;·&nbsp;</span>
                      <span
                        class="num"
                        style={{color: context.props.themeColor}}>
                        {context.props.data.view_count}</span>
                      <span>浏览</span>
                    </div>)
                  }
                </div>

              </div>
            )
          }
        </div>
      </div>
    )
  }
}
const listItem = {
  functional: true,
  props: ['data', 'themeColor','orgId'],
  render(h, context) {
    let banner = ''
    let backgroundImageType = ''
    let {config:{module,common,page},table_name} = context.props.data
    //判断营销应用的banner
    if(module !== undefined && table_name !== 'act_mger'){
      let {elements:{banner:actBanner}} = module
      if(actBanner.images) {
        banner = actBanner.images[0]
      }else{
        banner = actBanner.src
      }

      if(page.homePage.background.indexOf('http') !== -1) {
        backgroundImageType = `background:url(${page.homePage.background}) no-repeat top center;background-size:100%`
      }else{
        backgroundImageType = `background-color:${page.homePage.background}`
      }
    }else {
      //获取活动管家
      let {banner:marketBanner} = common
      banner = marketBanner[0]
    }
    return (
      <div class="list-item" onClick={context.listeners.click} data-link={context.data.attrs['data-link']}>
        <div class="left" style={backgroundImageType}>
          <img src={banner} alt=""/>
        </div>
        <div class="right">
          <div class="title">
            {
              context.props.data.activity_status === '0'
                ? (
                  <span class="label uninitiated">未发布</span>
                ) : (
                  <span class="label" style={{backgroundColor: getStatusColor(context.props.data.status)?getStatusColor(context.props.data.status):context.props.themeColor}}>{getStatusInfo(context.props.data.status)}</span>
                )
            }
            <span class="txt">{context.props.data.title}</span>
          </div>
          {
            [ACTIVITY_TYPE.REGULAR, ACTIVITY_TYPE.BD_APP].includes(+context.props.data.type) ? (
              <div class="desc">
                <div class="area">{context.props.data.start_time}</div>
                {
                  (+context.props.orgId !== 340753) && (<div class="party"><span class="num" style={{color: context.props.themeColor}}>{context.props.data.join_count}</span><span>人参与</span></div>)
                }
              </div>
            ) : (
              <div class="description">
                <div class="item">{context.props.data.config.common.targetGroup}</div>
                <div class="item">{context.props.data.config.common.address}</div>
                <div class="desc">
                  <div class="area">{context.props.data.config.common.time}</div>
                  <div class="party"><span class="num" style={{ color: context.props.themeColor }}>{context.props.data.join_count}</span><span>人参与</span></div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

const mobileNav = {
  props: ['list', 'tabList', 'themeColor', 'viewType' ,'orgId'],
  data() {
    return {
      activeIndex: 0
    }
  },
  components: {
    listItem,
    listItemExpansion
  },
  methods: {
    handleClickNav(e) {
      this.activeIndex = e.currentTarget.dataset.indexf
      this.$emit('mobileClickNav', {id: e.currentTarget.dataset.id, index: this.activeIndex})
    },
    handleClickItem(e) {
      window.location.href = e.currentTarget.dataset.link
    }
  },
  render() {
    return (
      <div class="mobile-nav">
        <div class="nav-bar">{
          +this.orgId !== 431555 && this.tabList.map((d, index) => (
            <div data-index={index} data-id={d.id} onClick={this.handleClickNav} class={(parseInt(this.activeIndex) === index) ? 'nav active' : 'nav'}>
              <span style={{ borderColor: this.themeColor }}>{d.title}</span>
            </div>
          ))
        }{
          +this.orgId === 431555 && this.tabList.map((d, index) => (
            <div style="display: flex;flex-direction: column;align-items: center;font-size: 0.6rem;line-height: 1.6rem;" data-index={index} data-id={d.id} onClick={this.handleClickNav} class={(parseInt(this.activeIndex) === index) ? 'nav active' : 'nav'}>
              <img src={d.image} style="width:2rem;"/>
              <b>{d.text}</b>
            </div>
          ))
        }
        </div>
        {
          this.list.length ? (
            <div class="list">{
              this.list.map(d => (
                this.viewType === '2' ? (
                  <list-item
                    key={d.id}
                    data-link={d.link}
                    onClick={this.handleClickItem}
                    themeColor={this.themeColor}
                    data={d}
                    orgId={this.$route.params.orgId}
                  ></list-item>
                ) : (
                  <list-item-expansion
                    data-link={d.link}
                    onClick={this.handleClickItem}
                    key={d.id}
                    themeColor={this.themeColor}
                    data={d}
                    orgId={this.$route.params.orgId}
                  ></list-item-expansion>
                )
              ))
            }
            </div>
          ) : (
            <div class="no-more-data">暂无活动</div>
          )
        }

        {
          (this.viewType === '1' && this.list.length >= 3) || (this.viewType === '2' && this.list.length >= 4) ? (
            <div class="end">
              <div class="line"></div>
              <div class="text">我是有底线的</div>
              <div class="line"></div>
            </div>
          ) : ('')
        }
      </div>

    )
  }
}

const mobile = {
  props: [
    'list',
    'homePage'
  ],
  components: {
    imgSwiper,
    mobileNav
  },
  methods: {
    handleClickNav(name) {
      console.log(name)
      if(+this.homePage.user_id===431555){
        if(+name.id===0){
          this.homePage.banner = ['https://image.wxopen.shenhudong.com/431555/431555_1.png']
        }
        if(+name.id===1){
          this.homePage.banner = ['https://image.wxopen.shenhudong.com/431555/431555_2.png']
        }
        if(+name.id===2){
          this.homePage.banner = ['https://image.wxopen.shenhudong.com/431555/431555_3.png']
        }
      }
      this.$emit('mobileClickNav', name)
    }
  },
  render(h, contetx) {
    /* eslint-disable-next-line */
    const { banner, title, color, nav,user_id } = this.homePage
    const viewType = this.homePage.view_type
    if(+user_id === 431555){
      for(let i=0;i<4;i++){
        if(i>0){
          nav[i].image = 'https://image.wxopen.shenhudong.com/431555/top_icon_'+(i)+'.png?v=1'
          if(i === 1){
            nav[i].text = '课后分享会'
          }
          if(i === 2){
            nav[i].text = '公益沙龙'
          }
          if(i === 3){
            nav[i].text = '家园茶话会'
          }
        }else{
          nav[i].image = 'https://image.wxopen.shenhudong.com/431555/index.png?v=1'
          nav[i].text = '主页'
        }
      }
    }
    window.document.title = title
    return (
      <div class="phone-wrapper">
        <div class="mobile">
          <div class="body">
            {!!banner.length && (
              <img-swiper
                imgList={banner}>
              </img-swiper>
            )}

            <mobile-nav
              themeColor={color}
              list={this.list}
              viewType={viewType}
              orgId={user_id}
              onMobileClickNav={this.handleClickNav}
              tabList={nav}>
            </mobile-nav>
          </div>
        </div>
      </div>
    )
  }
}

export default mobile